import React, { createContext, useContext, useEffect } from 'react';
import { useAuthStore } from '../store/authStore';

const AuthContext = createContext<ReturnType<typeof useAuthStore> | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const authStore = useAuthStore();

  // NOTE: Auth initialization is handled by AuthInitializer in _layout.tsx
  // Removing duplicate initialization to prevent race conditions

  return <AuthContext.Provider value={authStore}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}

